import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts/highstock"
import HighchartsExporting from "highcharts/modules/exporting"
import { DataframeData } from "../../PortfolioManagement/types"
import { useHighchartOptions } from "../hooks/useHighchartOptions"

// Initialize the exporting module
HighchartsExporting(Highcharts)

interface DatavizChartProps {
  apiData: DataframeData
  zScore: boolean
}

const DatavizChart: React.FC<DatavizChartProps> = ({ apiData, zScore }) => {
  const options = useHighchartOptions(apiData, zScore)

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType="stockChart"
      options={options}
      containerProps={{ style: { height: "100%", width: "100%" } }}
    />
  )
}

export default DatavizChart
